const API_URL = process.env.API_URL;

export const getEnquiry = (code) =>
    fetch(`${API_URL}/enquiry?code=${code}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        }
    })

export const getProgrammes = () =>
    fetch(`${API_URL}/enquiry/programmes`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        }
    })

export const getChannels = () =>
    fetch(`${API_URL}/enquiry/channels`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        }
    })

export const createEnquiry = (content) =>
    fetch(`${API_URL}/enquiry`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(content)
    })



// WEBPACK FOOTER //
// ./src/services/api/enquiry.js